var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1482_10372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4165 2.33337H2.33317C2.02375 2.33337 1.72701 2.45629 1.50821 2.67508C1.28942 2.89388 1.1665 3.19062 1.1665 3.50004V11.6667C1.1665 11.9761 1.28942 12.2729 1.50821 12.4917C1.72701 12.7105 2.02375 12.8334 2.33317 12.8334H10.4998C10.8093 12.8334 11.106 12.7105 11.3248 12.4917C11.5436 12.2729 11.6665 11.9761 11.6665 11.6667V7.58337",
    stroke: "#8A98A9",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7915 1.45838C11.0236 1.22632 11.3383 1.09595 11.6665 1.09595C11.9947 1.09595 12.3094 1.22632 12.5415 1.45838C12.7736 1.69045 12.9039 2.0052 12.9039 2.33338C12.9039 2.66157 12.7736 2.97632 12.5415 3.20838L6.99984 8.75005L4.6665 9.33338L5.24984 7.00005L10.7915 1.45838Z",
    stroke: "#8A98A9",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1482_10372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.464b7b824ee08eed41e03019fa01d099.svg";
export { ForwardRef as ReactComponent };